import { createWebappApiClient } from "./WebappApiClient";

export type { WebappApiClient } from "./WebappApiClient";

export const webappApiClient = createWebappApiClient();

export const { platform: platformApi, configurator: configuratorApi, cms: cmsApi } = webappApiClient;
